import { HttpService } from "./https.service";
import { BASE_URL } from "../../config/config";
import { AutomationCompleteFormData } from 'custom-type';

const http = new HttpService();

export class InstagramDMAutomation {
    async getInfluencerAccounts(data: {influencer_id: number, ig_id?: number}) {
        try {
            const path = BASE_URL + `/influencer/instagram/accounts`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getInfluencerAccounts :: ${error}`);
        }
    }

    async connectInstagram(data: any) {
        try {
            const path = BASE_URL + `/influencer/instagram/connect`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getInfluencerAccounts :: ${error}`);
        }
    }
    
    async getInstagramPostMedias(data: {connected_instagram_account_id: string; ig_access_token: string}) {
        try {
            const path = BASE_URL + `/influencer/instagram/getPostMedias`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getInstagramPostMedias :: ${error}`);
        }
    }

    // async automationSaveAsDraft(data: AutomationCompleteFormData) {
    //     try {
    //         const path = BASE_URL + `/influencer/instagram/automation/saveDraft`;
    //         const response = await http.postRequest(path, data, null);
    //         return response;
    //     } catch (error) {
    //         throw new Error(`getInstagramPostMedias :: ${error}`);
    //     }
    // }

    async automationSave(data: AutomationCompleteFormData) {
        try {
            const path = BASE_URL + `/influencer/instagram/automation/save`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getInstagramPostMedias :: ${error}`);
        }
    }

    async automationUpdate(data: AutomationCompleteFormData) {
        try {
            const path = BASE_URL + `/influencer/instagram/automation/update`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getInstagramPostMedias :: ${error}`);
        }
    }

    async getIgAutomations(data: {influencer_id: number}) {
        try {
            const path = BASE_URL + `/influencer/instagram/automations`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getInfluencerAccounts :: ${error}`);
        }
    }

    async getDraftAutomation(data: {influencer_id: number, ig_automation_id: string | number}) {
        try {
            const path = BASE_URL + `/influencer/instagram/draft/automation`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getInfluencerAccounts :: ${error}`);
        }
    }

    async deleteAutomation(data: any) {
        try {
            const path = BASE_URL + `/influencer/instagram/automations/deleteAutomation`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getInfluencerAccounts :: ${error}`);
        }
    }

    async onOffAutomation(data: {ig_automation_id: number, status: string}) {
        try {
            const path = BASE_URL + `/influencer/instagram/automations/onOffAutomation`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getInfluencerAccounts :: ${error}`);
        }
    }
}